import { render, staticRenderFns } from "./ProductProcedure.vue?vue&type=template&id=222d4cd6&"
import script from "./ProductProcedure.vue?vue&type=script&lang=js&"
export * from "./ProductProcedure.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports